import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { BaseAPIService } from '@app/Services/api.base.service';
import { IDriver } from '../Models/IDriverList';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { IGridCols } from '../Models/IGridCols';
import { IFileDownload } from '../Models/IFileDownload';


@Component({
  selector: 'app-upload-drivers',
  templateUrl: './upload-drivers.component.html',
  styleUrls: ['./upload-drivers.component.scss'],
  providers: [MessageService],
  animations: [
    trigger('rowExpansionTrigger', [
      state('void', style({
        transform: 'translateX(-10%)',
        opacity: 0
      })),
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class UploadDriversComponent implements OnInit {

  uploadedFiles: any[] = [];
  fileNote: any[];
  drivers: any[];
  cols: Array<IGridCols>;
  labels: any;
  messages: any;
  infoMessage: string;
  driverData: any;
  fileName: string = '';
  mask: number;
  response: any[];
  Uploadedfile: void;
  errorMessage: string;
  driversList: IDriver[];
  noData: boolean = false;
  deleteflag: boolean = false;
  delete_mask: any;
  delete_filename: any;
  isLoading: boolean = false;
  fileNameModel: any;
  files: any;
  showWarningmodal: boolean = false;
  isPagination: boolean = false;
  deleteFileId: number = 0;
  showUploadModal: boolean = false;
  contentHeader: string = label.driverUpload;
  formInvalid: boolean = true;
  requiredMask: string = '';
  isValidFile: boolean = true;

  constructor(
    private readonly messageService: MessageService,
    private readonly translate: TranslateService,
    private readonly baseService: BaseAPIService,
    private readonly validateService: ValidateRulesService) { }

  ngOnInit() {
    this.labels = label;
    this.messages = message;
    this.cols = [
      { field: 'fileName', header: this.labels.driverFileName },
      { field: 'mask', header: this.labels.mask },
      { field: 'uploadedBy', header: this.labels.uploadedBy },
      { field: 'uploadedOn', header: this.labels.uploadedOn }
    ];

    this.getAllDrivers();
  }

  deleteDriver(driverData: any) {
    this.deleteflag = true;
    this.deleteFileId = driverData.id;
    this.showWarningmodal = true;
  }

  download(data: any) {
    this.isLoading = true;
    const fileId = data.id;
    this.baseService.GetWithHeaders(`/DriverManagement/DownloadDriverFileById?fileId=${fileId}`, {}).subscribe((result: IFileDownload) => {
      const fileName = result.fileName;
      const blobPart = window.atob(result.fileContentResult.fileContents);
      const blob = new Blob([blobPart], { type: 'text/xml' });
      saveAs(blob, fileName);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.downloadError), key: 'error' });
    });

  }

  confirm() {
    this.isLoading = true;
    this.showWarningmodal = false;
    this.messageService.clear('c');
    if (this.deleteflag === true) {
      this.baseService.PatchWithHeaders(`/DriverManagement/DeleteDriverFileById/${this.deleteFileId}`, {}, {}).subscribe((result: boolean) => {
        this.isLoading = false;
        if (result === true) {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.deleteSuccess), key: 'success' });
          this.deleteflag = false;
          this.getAllDrivers();
        }
      }, () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.deleteError), key: 'error' });
      });
    } else {
      this.isLoading = false;
      //empty condition block
    }
  }

  getAllDrivers() {
    this.isLoading = true;
    this.baseService.GET('/DriverManagement/AllDriverDetail').subscribe((result: Array<IDriver>) => {
      if (result && result.length > 0) {
        this.driversList = result;
        this.isLoading = false;
        this.isPagination = this.driversList.length < 10 ? false : true;
      }
      else {
        this.driversList = [];
        this.noData = true;
        this.isPagination = false;
        this.isLoading = false;
      }
    }, () => {
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant("Error fetching driver list details"), key: 'error' });
    });
  }

  cancel() {
    this.messageService.clear('c');
    this.deleteflag = false;
    this.showWarningmodal = false;
    this.showUploadModal = false;
    this.isLoading = false;
    this.fileNameModel = '';
  }

  public ValidateForm() {
    this.requiredMask = '';
    this.requiredMask = this.validateService.requiredElement(this.mask.toString(), 'Mask', 1, 20, true);
    this.formInvalid = this.requiredMask !== '';
  }

  FileKeyDownText(event: Event) {
    if (event != null) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  //Driver File Upload Section

  onShowUploadModal() {
    this.showUploadModal = true;
    this.fileNameModel = '';
    this.mask = null;
    this.formInvalid = true;
  }

  UploadFileEvent($event: any) {
    this.isLoading = true;
    this.files = $event.target.files;
    this.fileNameModel = $event.target.files[0].name;
    if (this.IsValidFile(this.files[0])) {
      this.showWarningmodal = false;
      this.showUploadModal = false;
      this.messageService.clear('c');
      const params: FormData = new FormData();
      params.append('driverFile', this.files[0], this.fileNameModel);
      this.UploadDriver(params);
    }
  }

  private IsValidFile(file: any): boolean {
    if (file.type !== 'text/xml') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.validFileError), key: 'error' });
      this.files = [];
      this.fileNameModel = '';
      this.isValidFile = false;
    }
    else if (file.size > 5000000) {
      this.files = '';
      this.fileNameModel = '';
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.maxFileSizeErr), key: 'error' });
      this.isValidFile = false;
    }
    else if (file.name.length > 50) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.filenamelengtherr), key: 'error' });
      this.files = [];
      this.fileNameModel = '';
      this.isValidFile = false;
    }
    else {
      this.isValidFile = true;
    }
    return this.isValidFile;
  }

  public UploadDriver(params: FormData) {
    const apiUrl = `/DriverManagement/UploadDriverFile/${this.mask}`;
    this.baseService.PostFormDataWithHeaders(apiUrl, {}, params).subscribe((result) => {
      this.showUploadModal = false;
      if (result && result !== 0) {
        this.getAllDrivers();
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: this.translate.instant(this.messages.fileuploaded), key: 'success' });
      } else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.filenotVerified), key: 'error' });
      }
    }, (error) => {
      console.log(error.error);
      this.fileNameModel = '';
      this.showUploadModal = false;
      this.isLoading = false;
      switch (error.error) {
        case 'Invalid file selection':
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant('Invalid file selection'), key: 'error' });
          break;
        case 'Invalid mask':
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant('Invalid mask'), key: 'error' });
          break;
        default: break;
      }
    });
  }

}
